import { render, staticRenderFns } from "./dispatch-timeline.vue?vue&type=template&id=84df4a4c&scoped=true"
import script from "./dispatch-timeline.vue?vue&type=script&lang=js"
export * from "./dispatch-timeline.vue?vue&type=script&lang=js"
import style0 from "./dispatch-timeline.vue?vue&type=style&index=0&id=84df4a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84df4a4c",
  null
  
)

export default component.exports